export { default as ProductViewVariants } from './ProductViewVariants'
